<template>
    <div class="card shadow-sm mb-5 p-5 card-flush ">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5> 
        </div>
        <div class="card-toolbar">
          <ButtonDropdownFilter
                :btn-title="$t('crm.pipeline.opportunities')"
                :options="opportunties"
                value-field="id"
                name-field="name"
                v-model="query.opportunity_id"
                :border="true"
            />
            <ButtonDropdownFilter
                :btn-title="$t('label.allSellers')"
                :options="salesPersons"
                value-field="id"
                name-field="fullname"
                v-model="query.seller_id"
                :border="true"
            />
            <div class="d-flex px-5 py-2 shadow-sm" :style="{'border': '1px solid ' + $getCssVariable('--bs-primary'), 'border-radius': '8px'}">
            <span class="me-5" :class="online ? 'text-gray-500' :  'text-primary'">{{ $t('pipelines.won') }}</span>
            <div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input bg-primary h-15px w-40px" type="checkbox" v-model="online" id="flexSwitchChecked" checked="checked" />
            </div>
            <span class="ms-5" :class="!online ? 'text-gray-500' :  'text-primary'">{{ $t('pipelines.lost') }}</span>
            </div>

        </div>
        </div>
       <Loader :isLoading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!Object.values(averageDurations)?.length" class="text-center">
                <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
                <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="Object.values(averageDurations)?.length" class="p-5 position-relative">
                <canvas id="kt_chartjs_duration_step" class="mh-400px"></canvas>
                <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div class="text-center">
                    <h1 class="display-2">{{globalAverageBuration}}</h1>
                    <span>{{ $t('pipelines.moyen_duration') }}</span>
                </div>
                </div>
            </div> 
          </div>
       </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import { computed, watch, onMounted, shallowRef, ref} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const online = ref(false)
const averageDurations = ref([])
const row = ref(0)
const column = ref(0)
const globalAverageBuration = ref(0)
const chartDurationRef = shallowRef(null)

const salesPersons = computed(() => store.getters['pipelines/getSalesPersons'])
const opportunties = computed(() => store.getters['pipelines/getPipelines'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => online.value, (value) => {
    query.value.status = value ? 'LOST' : 'WON'
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          let answer = res?.response?.data || res?.data 
          row.value = res.row
          column.value = res.column
          const durations = answer?.averageDurations ?? {};
          if(durations){
            averageDurations.value = Object.entries(durations)
            .filter(([key]) => key !== 'global_average')
            .map(([, value]) => value);
            
            globalAverageBuration.value = durations.hasOwnProperty('global_average') ? durations['global_average'] : 0
          }
          
        }),
        store.dispatch('pipelines/loadPipelines'),
        store.dispatch('pipelines/loadSalesPersons')
    ]).then(() => {
      chartDurationStep()
    })
}

function chartDurationStep(){
    let names = [];
    let percentages = [];
    let colors = ['#0072CE', '#024983', '#0072CE66', '#E51335', '#F07817', '#646E7B'];
  
    Object.keys(averageDurations.value).forEach(key => {
      if(averageDurations.value[key] > 0){
        names.push(key)
        percentages.push(averageDurations.value[key])
      }
    });

    if (names.length === 0 || percentages.length === 0) {
      averageDurations.value = [];
    }

    let ctx = document.getElementById('kt_chartjs_duration_step');
  
    if (ctx) {
      if(Chart.getChart("kt_chartjs_duration_step")) {
        Chart.getChart("kt_chartjs_duration_step")?.destroy()
      }
      let context = ctx.getContext('2d');
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');
  
      let data = {
          labels: names,
          datasets: [{
            data: percentages,
            backgroundColor: colors,
            hoverOffset: 10
        }]
      };
  
      let config = {
          type: 'doughnut',
          data: data,
          options: {
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                          let percentageLabel = i18n.global.t('crm.statistics.percentage');
                            return `${percentageLabel}: ${$formatLocalAmount(context.parsed)} %`;
                        }
                    }
                }
            },
            responsive: true,
            elements: {
              arc: {
                  borderWidth: 1 
              }
            },
            cutout: '40%'
          },
          defaults:{
              global: {
                  defaultFont: fontFamily
              }
          }
      };
  
      if (!chartDurationRef.value) {
        chartDurationRef.value = new Chart(ctx, config);
      }else{
        chartDurationRef.value.destroy()
        chartDurationRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})
</script> 